var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculationAnnotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_528_132468)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.3,
    stroke: "#BC0000",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3111 19.6H11.4222V17.6444H13.3778V16.5333H11.4222V14.5778H10.3111V16.5333H8.35556V17.6444H10.3111V19.6ZM15.0889 18.8222H19.5556V17.7333H15.0889V18.8222ZM15.0889 16.4444H19.5556V15.3333H15.0889V16.4444ZM15.9111 12.8222L17.2667 11.4667L18.6222 12.8222L19.4222 12.0222L18.0667 10.6667L19.4222 9.31111L18.6222 8.51111L17.2667 9.86667L15.9111 8.51111L15.1111 9.31111L16.4667 10.6667L15.1111 12.0222L15.9111 12.8222ZM8.68889 11.2222H13.0444V10.1111H8.68889V11.2222ZM7.33333 22C6.97778 22 6.66667 21.8667 6.4 21.6C6.13333 21.3333 6 21.0222 6 20.6667V7.33333C6 6.97778 6.13333 6.66667 6.4 6.4C6.66667 6.13333 6.97778 6 7.33333 6H20.6667C21.0222 6 21.3333 6.13333 21.6 6.4C21.8667 6.66667 22 6.97778 22 7.33333V20.6667C22 21.0222 21.8667 21.3333 21.6 21.6C21.3333 21.8667 21.0222 22 20.6667 22H7.33333ZM7.33333 20.6667H20.6667V7.33333H7.33333V20.6667ZM7.33333 7.33333V20.6667V7.33333Z",
    fill: "#BC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_528_132468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculationAnnotation);
export default __webpack_public_path__ + "static/media/calculation-annotation.a3de24334124759a1d5e67bd3159f4a0.svg";
export { ForwardRef as ReactComponent };